import React, { Component } from 'react'
import Service from '../../../services';
import { connect } from 'react-redux';
import withRouter from '../../../lib/withRouter';
import { Toolbar } from 'primereact/toolbar';
import { Menu } from 'primereact/menu';
import { DataTable } from 'primereact/datatable';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';
import SvgViewer from '../../../customComponents/svgViewer';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import Authorizer, { PERMISSIONS } from '../../../session/authorizer';
import { InputText } from 'primereact/inputtext';
import { getBoardsData } from '../../../../store/actions';
import { baseUrlAdmin } from '../../../../store/apiConstants';
import SingleQuestion from '../../../questionBank/common/singleQuestion';
import { userAssignedBoards } from '../../../../store/selectors/userAssignedBoards';
import { Dropdown } from 'primereact/dropdown';
import { getFormFields, isFormValid, onChipsChange, onTextChange, isFieldValid, isValidMobile, onNumberChange, onDropDownChange, onChoiceChange, onEmailChange, isValidEmail, isValidUrl } from '../../../../utile/formHelper';
import { QuestionTargets, QuestionTypeKeys, QuestionTypesShort } from '../../../questionBank/constants';
import { BasicLazyParams, getServerTime } from '../../../../utile';
import PreviewQuestion from '../../../questionBank/common/previewQuestion';
import _ from 'lodash';
import uuidv4 from 'uuid/v4';
import LoadingComponent from '../../../loadingComponent';
import QuestionInTable from '../../../questionBank/common/questionInTable';
import moment from 'moment';
import { TabView, TabPanel } from 'primereact/tabview';
import { Chips } from 'primereact/chips';
import { DeleteIcon, PreviewIcon } from '../../../svgIcons';
import { FIELDS_INFO } from '../../../../constants';
import InputTextB from '../../../customComponents/inputTextB';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { ProgressBar } from 'primereact/progressbar';
import { Message } from 'primereact/message';
import BulkQuestionSelector from './bulkQuestionSelector';
import ExamDetailsForm from './examDetailsForm';

const adhocFieldss = require('../examForms/adhoc.json');
let adhocFields = _.cloneDeep(adhocFieldss);

// Update the getQuestionTypeValue function to handle PQS/PQM mapping
const getQuestionTypeValue = (displayName) => {
    if (!displayName) return 'SCCT'; // Default

    // Map passage sub-question types to their parent types for consistent matching
    if (displayName === 'PQS') return 'PSGS';
    if (displayName === 'PQM') return 'PSGM';

    const found = QuestionTypesShort.find(type => type.label === displayName);
    // If found, use the value, otherwise fallback to the display name
    return found ? found.value : displayName;
}

class CreateAdhoc extends Component {
    constructor(props) {
        super(props);

        // Remove the questionTarget default from formFields
        this.formFields = getFormFields(adhocFields, {});
        this.state = {
            exam: this.formFields.data,
            formValidations: this.formFields.formValidations,
            examTemplates: [],
            boards: [],
            classes: [],
            groups: [],
            subjects: [],
            boardId: null,
            classId: null,
            groupId: null,
            subjectId: null,
            boardName: null,
            className: null,
            groupName: null,
            subjectName: null,
            isLoading: false,
            columns: [{ columnName: 'Question Type', isVisible: true, id: 'questionType' }],
            showSearch: false,
            globalSearch: '',
            lazyParams: BasicLazyParams,
            questions: [],
            currentStep: 1,
            selectedQIds: [],
            questionIds: [],
            selectedExamQuestions: [],
            showBulkQuestionSelector: false,
            availableQuestions: [],
            selectedBulkQuestions: [],
            currentSubjectId: null,
            currentSectionName: null,
            currentQuestionType: null,
            isLoadingQuestions: false,
            questionSelection: {
                subjectId: null,
                sectionName: null,
                questionType: null
            },
            questionFilters: {
                chapterId: null,
                topicId: null,
                difficulty: null
            }
        }
        this.service = new Service();
    }

    isColumnVisible = (id) => {
        return this.state.columns.filter(c => c.id == id)[0].isVisible;
    }

    prepareCloneData = (originalExam) => {
        // Fields to exclude from cloning
        const fieldsToExclude = [
            '_id',
            'examId',
            'createdAt',
            'updatedAt',
            'createdBy',
            'updatedBy',
            'assignedSections',
            'assignedStudents',
            'assignedSectionsOrStudents',
            'branchId',
            'assignType',
            'examResults',
            'status',
            'publishDate',
            'isPublished',
            'resultsPublished',
            'totalStudentsAssigned',
            'totalStudentsAttempted',
            'averageScore',
            'maxScore',
            'minScore',
            'lastAssignedDate',
            'lastResultGeneratedDate',
            'exported',
            'exportMsg',
            'lastExportDate',
            'exportMsg',
            'exportStarted'
        ];

        // Create a clone of the original exam
        const clonedExam = { ...originalExam };

        // Remove unnecessary fields
        fieldsToExclude.forEach(field => {
            delete clonedExam[field];
        });

        // Keep the original exam name for cloning (user can modify if needed)
        // if (clonedExam.examName) {
        //     clonedExam.examName = `Copy of ${clonedExam.examName}`;
        // }

        // Reset dates to current date if they exist
        const currentDate = new Date().toISOString();
        if (clonedExam.examStartDate) {
            clonedExam.examStartDate = '';
        }
        if (clonedExam.examEndDate) {
            clonedExam.examEndDate = '';
        }
        if (clonedExam.startTime) {
            clonedExam.startTime = '';
        }
        if (clonedExam.endTime) {
            clonedExam.endTime = '';
        }

        // Reset any status fields
        clonedExam.isDraft = true;
        clonedExam.isActive = false;

        // If there are subjects with questions, preserve the structure but reset any IDs
        if (clonedExam.subjects && Array.isArray(clonedExam.subjects)) {
            clonedExam.subjects = clonedExam.subjects.map(subject => ({
                ...subject,
                // Remove any subject-specific IDs if they exist
                assignedQuestionIds: subject.assignedQuestionIds || [],
                questions: subject.questions ? subject.questions.map(q => ({
                    ...q,
                    // Keep question structure but remove result-specific data
                    studentAnswers: undefined,
                    attempts: undefined,
                    timeTaken: undefined
                })) : []
            }));
        }

        return clonedExam;
    }

    formGradesDataForEdit = (editExam) => {
        if (this.props.boards && this.props.boards.length) {
            const _classes = [];
            const _groups = [];
            const selectedBoard =
                this.props.boards &&
                this.props.boards &&
                this.props.boards.length > 0 &&
                this.props.boards.find((board) => board.boardId === editExam.boardId);
            if (selectedBoard && selectedBoard.classes && selectedBoard.classes.length > 0) {
                selectedBoard.classes.map((item) => _classes.push({ className: item.className, classId: item.classId }));
            }

            const selectedClass = selectedBoard && selectedBoard.classes.find((_class) => _class.classId === editExam.classId);
            if (selectedClass && selectedClass.groups && selectedClass.groups.length > 0) {
                selectedClass.groups.map((item) => _groups.push({ groupName: item.groupName, groupId: item.groupId }));
                _groups.find((g) => g.groupId == editExam.groupId)

                this.setState(
                    {
                        boardId: editExam.boardId,
                        classId: editExam.classId,
                        groupId: editExam.groupId,
                        classes: _classes,
                        groups: _groups,
                        boardName: selectedBoard.boardName,
                        className: selectedClass.className,

                    }, () => {
                        this.getCurriculumData(true);
                    });
            }
        }
    }

    getTemplates = () => {
        this.setState({
            isLoading: true
        });
        let { lazyParams, globalSearch } = this.state;
        const academicYear = localStorage.getItem("userAcademicYear");
        let url = `${baseUrlAdmin}/examtemplate/gettemplates?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&academicYear=${academicYear}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder == 1 ? '' : '-'}${lazyParams.sortField}` : ''}`
        this.service.post(url, {}, true).then((data) => {
            if (data && data.res && data.res.data && data.res.data.examTemplates.length) {
                this.setState({
                    examTemplates: data.res.data.examTemplates,
                    isLoading: false,
                });
            } else {
                this.setState({
                    isLoading: false
                })
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
        });
    }

    // Ensures all questions have valid qNo values
    ensureQuestionNumbers = (exam) => {
        if (!exam || !exam.subjects) return;

        // Process each subject
        exam.subjects.forEach((subject, subjectIndex) => {
            if (!subject.questions) return;

            let questionCounter = 1;
            // Assign sequential qNo to each question if not already set
            subject.questions.forEach((question) => {
                if (!question.qNo || isNaN(parseInt(question.qNo))) {
                    question.qNo = questionCounter++;
                } else {
                    // If qNo exists, convert to number to ensure proper sorting
                    question.qNo = parseInt(question.qNo);
                }
            });

            // Sort questions by qNo to ensure they display in correct order
            subject.questions.sort((a, b) => (a.qNo || 0) - (b.qNo || 0));
        });
    }

    formQuestionsFromExam = (exam) => {
        let questions = [];
        exam.subjects.forEach((s) => {
            questions = [...questions, ...s.questions]
        })
        return questions;
    }

    componentDidMount() {
        if (!this.props.boards || !this.props.boards.length) {
            this.props.getBoardsData(true);
        }
        this.getTemplates();

        // Notify parent component of initial step
        if (this.props.onStepChange) {
            this.props.onStepChange(this.state.currentStep);
        }

        if (this.props.editExamId) {
            this.setState({
                isLoading: true
            });
            this.service.get(`${baseUrlAdmin}/examination/${this.props.editExamId}/exam-type/AdhocMockTest`, true).then((data) => {
                if (data && data.res && data.res.Item && data.res.Item.length) {
                    // Ensure questions have qNo values before setting state
                    const examData = data.res.Item[0];
                    this.ensureQuestionNumbers(examData);

                    this.setState({
                        exam: examData,
                        selectedExamQuestions: this.formQuestionsFromExam(examData),
                        isLoading: false,
                    }, () => this.formGradesDataForEdit(examData));
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
            });
        } else if (this.props.cloneExamData && this.props.cloneExamData.examId) {
            this.setState({
                isLoading: true
            });
            this.service.get(`${baseUrlAdmin}/examination/${this.props.cloneExamData.examId}/exam-type/AdhocMockTest`, true).then((data) => {
                if (data && data.res && data.res.Item && data.res.Item.length) {
                    const originalExam = data.res.Item[0];
                    const clonedExam = this.prepareCloneData(originalExam);
                    this.setState({
                        exam: clonedExam,
                        selectedExamQuestions: this.formQuestionsFromExam(originalExam),
                        isLoading: false,
                    }, () => this.formGradesDataForEdit(originalExam));
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            }).catch(e => {
                this.setState({
                    isLoading: false
                });
            });
        }
    }

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [], groups: [],
            classId: null, groupId: null,
            subjects: [], subjectId: null,
            chapters: [], chapterId: null,
            topics: [], topicId: null,
            content: null,
        });
        const _classes = [];
        const selectedBoard = this.props.boards && this.props.boards.find((board) => board.boardId === boardId);
        if (selectedBoard && selectedBoard.classes && selectedBoard.classes.length > 0) {
            selectedBoard.classes.forEach((item) => _classes.push({ className: item.className, classId: item.classId }));
        }
        this.setState((prevState) => ({
            exam: {
                ...prevState.exam,
                boardId,
                boardName: selectedBoard.boardName,
            },
            classes: _classes,
            boardId,
            boardName: selectedBoard.boardName,
            resourseOrigin: selectedBoard.isBase ? 'upload' : null
        }));

    };

    onChangeClass = (classId) => {
        this.setState({
            groups: [], groupId: null,
            subjects: [], subjectId: null,
            chapters: [], chapterId: null,
            topics: [], topicId: null,
            content: null,
        });
        const boardId = this.state.boardId;
        const _groups = [];
        const selectedBoard =
            this.props.boards && this.props.boards.find((board) => board.boardId === boardId);
        const selectedClass = selectedBoard.classes.find((_class) => _class.classId === classId);
        if (selectedClass && selectedClass.groups && selectedClass.groups.length > 0) {
            selectedClass.groups.map((item) => _groups.push({ label: item.groupName, value: item.groupId }));
            this.setState((prevState) => {
                return {
                    exam: {
                        ...prevState.exam,
                        classId,
                        className: selectedClass.className,
                        groupId: _groups[0].value,
                        groupName: _groups[0].label,
                    },
                    groups: _groups,
                    classId,
                    className: selectedClass.className,
                    groupId: _groups[0].value,
                    groupName: _groups[0].label,
                }
            }, () => {
                this.getCurriculumData();
            }
            );
        }
    }

    getSelectedCurriculum = (subjects) => {
        let { subjectId, chapterId, topicId } = this.state.exam;
        let selectedSubject = subjects.find((subject) => subject.subjectId == subjectId);
        let selectedChapter = selectedSubject && selectedSubject.chapters && selectedSubject.chapters.find(c => c.chapterId == chapterId);
        let selectedTopic = selectedChapter && selectedChapter.topics && selectedChapter.topics.find(c => c.topicId == topicId);

        return {
            subjects,
            chapters: selectedSubject.chapters,
            topics: (selectedChapter && selectedChapter.topics) ? selectedChapter.topics : [],
            subjectId,
            chapterId,
            topicId,
            subjectName: selectedSubject.subjectName,
            chapterName: selectedChapter ? selectedChapter.chapterName : null,
            topicName: selectedTopic ? selectedTopic.topicName : null,
            content: null,

        };

    }

    getCurriculumData = (isEdit) => {
        const { boardId, classId, groupId } = this.state;
        if (boardId && classId && groupId) {
            this.setState({
                isLoading: true
            })
            const url = `${baseUrlAdmin}/board/${boardId}/class/${classId}/group/${groupId}/active`;
            this.service.get(url, true).then((data) => {
                if (data && data.res && data.res.Item) {
                    this.setState({
                        curriculumInfo: data.res.Item,
                        subjects: data.res.Item.subjects,
                        isLoading: false,

                        //   ...selected
                    }, () => {

                    });
                } else {
                    this.setState({
                        isLoading: false
                    })
                }
            });
            //  getCurriculum(boardId, classId, groupId);
        } else {
            this.setState({
                isLoading: false
            })
            // this.snackBarOpen('select board, class and group id');
        }
    };


    onChangeSubject = (sId, subjectId) => {
        let selectedSubject = this.state.subjects.find((subject) => subject.subjectId == subjectId);
        let exam = this.state.exam;

        exam.subjects.forEach((s) => {
            if (s.id == sId) {
                s.subjectId = subjectId;
                s.subjectName = selectedSubject.subjectName
            }
        })

        this.setState((prevState) => {
            return {
                exam
            };
        });
    };

    onChangeChapter = (chapterId) => {
        let selectedChapter = this.state.chapters.filter((chapter) => chapter.chapterId == chapterId);
        this.setState(
            {
                topics: selectedChapter[0].topics,
                chapterId,
                chapterName: selectedChapter[0].chapterName,
                topicId: null,
                content: null,

            });
    };

    onChangeTopic = (topicId) => {
        let selectedTopic = this.state.topics.find(topic => topic.topicId == topicId);
        this.setState(
            {
                topicId,
                topicName: selectedTopic.topicName
            });
    };


    updateDateFileds = (isApplicable) => {
        if (isApplicable == 'closed') {
            adhocFields = adhocFields.map(field => {
                if (field.FieldName == 'fromDateTime' || field.FieldName == 'toDateTime') {
                    field.Required = true;
                }
                return field;
            });

            this.formFields = getFormFields(adhocFields, this.state.org);

            const currentTime = getServerTime();
            this.setState((prevState) => ({
                exam: {
                    ...prevState.exam,
                    fromDateTime: currentTime,
                    toDateTime: currentTime
                },
                formValidations: this.formFields.formValidations
            }))

        } else {
            adhocFields = adhocFields.map(field => {
                if (field.FieldName == 'fromDateTime' || field.FieldName == 'toDateTime') {
                    field.Required = undefined;
                }
                return field;
            });

            this.formFields = getFormFields(adhocFields, this.state.org);

            this.setState((prevState) => ({
                exam: {
                    ...prevState.exam,
                    fromDateTime: null,
                    toDateTime: null
                },
                formValidations: this.formFields.formValidations
            }))
        }
    }



    isAdditionalValid = (exam) => {
        let { formValidations } = this.state;
        let isValid = true;


        if (exam.testType == 'closed') {
            if (!(moment(exam.fromDateTime).isBefore(exam.toDateTime))) {
                formValidations.fields['fromDateTime'] = {
                    ...formValidations.fields['fromDateTime'],
                    isValid: false,
                    errorMsg: `Exam start date and time should less the end date.`
                }
                isValid = false;
            }
        }


        if (exam.subjects && exam.subjects.length) {
            let isSubjectNotSelected = false;
            let isDuplicateSubject = false;

            let subjectIds = [];
            exam.subjects.forEach(s => {
                if (s.subjectId == '') {
                    isSubjectNotSelected = true
                    isValid = false
                } else {
                    if (subjectIds.includes(s.subjectId)) {

                        isDuplicateSubject = true
                        isValid = false
                    }
                    subjectIds.push(s.subjectId)
                }
            });


            if (isSubjectNotSelected) {
                formValidations.fields['subjects'] = {
                    ...formValidations.fields['subjects'],
                    isValid: false,
                    errorMsg: `Please select all subjects`
                }
            } else {
                formValidations.fields['subjects'] = {
                    ...formValidations.fields['subjects'],
                    isValid: true,
                    errorMsg: ``
                }
            }


            if (!isSubjectNotSelected) {
                if (isDuplicateSubject) {
                    formValidations.fields['subjects'] = {
                        ...formValidations.fields['subjects'],
                        isValid: false,
                        errorMsg: `Duplicate subjects `
                    }
                } else {
                    formValidations.fields['subjects'] = {
                        ...formValidations.fields['subjects'],
                        isValid: true,
                        errorMsg: ``
                    }
                }
            }
        }

        if (exam.testType == 'closed') {
            if (!(moment(exam.fromDateTime).isAfter(getServerTime()))) {
                formValidations.fields['fromDateTime'] = {
                    ...formValidations.fields['fromDateTime'],
                    isValid: false,
                    errorMsg: `Exam start time must be greater than current time.`
                }
                isValid = false;
            }


            if (!(moment(exam.fromDateTime).isBefore(exam.toDateTime))) {
                formValidations.fields['toDateTime'] = {
                    ...formValidations.fields['toDateTime'],
                    isValid: false,
                    errorMsg: `Exam end time must greater than start time.`
                }
                isValid = false;
            }

        }

        if (!exam.totalTime || parseInt(exam.totalTime) <= 0) {
            formValidations.fields['totalTime'] = {
                ...formValidations.fields['totalTime'],
                isValid: false,
                errorMsg: 'Total time is required and must be greater than 0'
            };
            isValid = false;
        } else if (parseInt(exam.totalTime) > 600) {
            formValidations.fields['totalTime'] = {
                ...formValidations.fields['totalTime'],
                isValid: false,
                errorMsg: 'Total time cannot exceed 600 minutes'
            };
            isValid = false;
        } else {
            formValidations.fields['totalTime'] = {
                ...formValidations.fields['totalTime'],
                isValid: true,
                errorMsg: ''
            };
        }



        this.setState({
            formValidations,
            exam
        })

        return isValid;
    }






    onProceed = () => {

        const {
            exam,
            currentStep
        } = this.state;

        // Check if all subjects have subjectId
        const invalidSubject = exam.subjects.some(subject => !subject.subjectId);
        if (invalidSubject) {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Select all subjects',
                life: 3000
            });
            return;
        }

        if (currentStep == 1) {
            const formStatus = isFormValid(adhocFields, this.formFields.formValidations, exam);
            if (!formStatus.formValidations.isFormValid) {
                this.setState({
                    isSubmitClick: true,
                    formValidations: formStatus.formValidations,
                });
            } else if (!this.isAdditionalValid(exam)) {

            } else {
                this.setState({
                    currentStep: 2
                }, () => {
                    // Notify parent component of step change
                    if (this.props.onStepChange) {
                        this.props.onStepChange(2);
                    }
                })
            }
        } else {

            this.validateAndSubmit();
        }
    }



    validateAndSubmit = async () => {
        const {
            exam,
            selectedExamQuestions,
        } = this.state;

        if (parseInt(exam.totalNoOfQuestions) != selectedExamQuestions.length) {
            this.toast.show({
                severity: 'error',
                summary: 'Invalid',
                detail: 'Please enter the required number of questions.',
                life: 3000
            });
            return;
        }

        // Set loading state
        this.setState({ isLoading: true });

        try {
            // Wait for template to be fetched
            const response = await this.service.get(
                `${baseUrlAdmin}/examtemplate/getTemplateById?templateId=${exam.templateId}`,
                true
            );

            if (!response?.res?.data) {
                throw new Error('Failed to fetch exam template');
            }

            const examTemplate = response.res.data;

            // Now process exam data with the fetched template
            let examToSave = this.processExamData(exam, examTemplate, selectedExamQuestions);
            examToSave.totalMarks = this.calculateTotalMarks();
            examToSave.examType = 'AdhocMockTest';

            // Proceed with saving/updating
            if (this.props.editExamId) {
                await this.updateExam(examToSave);
            } else {
                await this.createExam(examToSave);
            }

        } catch (error) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'An error occurred',
                life: 3000
            });
        }
    }

    processExamData = (fExam, examTemplate, selectedExamQuestions) => {
        let finalExam = _.cloneDeep(fExam);
        let qNo = 1;

        finalExam.subjects.forEach((subject, index) => {
            // Find matching subject from template
            const templateSubject = examTemplate?.subjects[index];

            // Set totalMarks from template subject
            subject.totalMarks = templateSubject ? templateSubject.totalMarks : 0;

            subject.questions = [];
            let subjectQuestions = selectedExamQuestions.filter((q) => q.subjectId == subject.subjectId);

            // NEW: Sort questions by section order first, then by passage question ID
            subjectQuestions.sort((a, b) => {
                // Get section priorities (index in sections array)
                const aSectionIndex = subject.sections?.findIndex(s => s.sectionName === a.sectionName) || 0;
                const bSectionIndex = subject.sections?.findIndex(s => s.sectionName === b.sectionName) || 0;

                // First sort by section order
                if (aSectionIndex !== bSectionIndex) {
                    return aSectionIndex - bSectionIndex;
                }

                // Then sort by passage question ID if it exists (for grouping passage sub-questions)
                const aId = a.psgQId || '';
                const bId = b.psgQId || '';
                if (aId !== bId) {
                    return aId.localeCompare(bId);
                }

                // Finally sort by question type or any other criteria you want
                return (a.questionType || '').localeCompare(b.questionType || '');
            });

            subjectQuestions.forEach(question => {
                question.qNo = qNo;
                subject.questions.push(question);
                qNo++;
            });

            subject.priority = (index + 1);

            // Process markingScheme within each section
            if (subject.sections && Array.isArray(subject.sections)) {
                subject.sections.forEach(section => {
                    // Find matching section from template subject
                    const templateSection = templateSubject?.sections?.find(
                        ts => ts.sectionName === section.sectionName
                    );

                    // Set section totalMarks from template
                    section.totalMarks = templateSection ? templateSection.totalMarks : 0;

                    if (section.markingScheme && Array.isArray(section.markingScheme)) {
                        section.markingScheme.forEach(schema => {
                            schema.negativeMarking = parseInt(schema.negativeMarking || 0);
                            schema.optionalQuestions = parseInt(schema.optionalQuestions || 0);
                            schema.partialMarking = parseInt(schema.partialMarking || 0);
                            schema.positiveMarking = parseInt(schema.positiveMarking || 0);
                            schema.totalMarkedQuestions = parseInt(schema.totalMarkedQuestions || 0);
                            schema.totalQuestions = parseInt(schema.totalQuestions || 0);
                            schema.totalSelectedQuestions = parseInt(schema.totalSelectedQuestions || 0);
                            schema.questionType = getQuestionTypeValue(schema.questionType) || schema.questionType;
                        });
                    }
                });
            }
        });

        // Process other exam fields
        finalExam.gradeId = finalExam.classId || '';
        finalExam.gradeName = finalExam.className || '';
        finalExam.totalMarkedQuestions = parseInt(finalExam.totalMarkedQuestions || 0);
        finalExam.totalNoOfQuestions = parseInt(finalExam.totalNoOfQuestions || 0);
        finalExam.totalTime = parseInt(finalExam.totalTime || 0);

        // Set exam totalMarks from template
        finalExam.totalMarks = examTemplate?.totalMarks || 0;

        if (!finalExam.questionType) {
            finalExam.questionType = finalExam.questionTypes || '';
        }

        // Remove date fields for open test type
        if (finalExam.testType === 'open') {
            delete finalExam.fromDateTime;
            delete finalExam.toDateTime;
        }

        return finalExam;
    }

    onAddQuestions = () => {
        let { selectedQuestions, exam } = this.state;
        if (selectedQuestions && selectedQuestions.length) {
            if (exam.noOfQuestions && exam.noOfQuestions != '') {
                if (exam.questions.length < parseInt(exam.noOfQuestions)) {
                    if (selectedQuestions && selectedQuestions.length) {
                        if ((selectedQuestions.length + exam.questions.length) <= parseInt(exam.noOfQuestions)) {
                            exam.questions = [...exam.questions, ...selectedQuestions];
                            exam.questions = [... new Set(exam.questions)]
                            this.setState({
                                exam: exam,
                                selectedQuestions: []
                            });
                        } else {
                            let removeCount = (selectedQuestions.length + exam.questions.length) - parseInt(exam.noOfQuestions);
                            this.toast.show({ severity: 'error', summary: 'Invalid', detail: `Number questions are exceeded, Remove ${removeCount} questions`, life: 3000 });
                        }
                    }
                } else {
                    this.toast.show({ severity: 'error', summary: 'Invalid', detail: 'You have already selected maximum number of question required for the Exam', life: 3000 });
                }
            } else {
                this.toast.show({ severity: 'error', summary: 'Invalid', detail: 'Please enter the number qustions before adding questions', life: 3000 });
            }
        } else {

            this.toast.show({ severity: 'error', summary: 'Invalid', detail: 'Please select questions to add', life: 3000 });
        }
    }



    removeQuestion = (remQ) => {
        let { selectedExamQuestions } = this.state;

        // Filter out the question to be removed
        selectedExamQuestions = selectedExamQuestions.filter((q) => q._id != remQ._id);

        // Recalculate section counts after removal
        const updatedExam = this.recalculateSectionCounts();

        this.setState({
            selectedExamQuestions,
            exam: updatedExam
        });
    }


    onColumnClick = (column) => {
        let columns = this.state.columns.map(c => {
            if (column.id == c.id) {
                c.isVisible = !c.isVisible;
            }
            return c;
        });
        this.setState({
            columns
        });
    }


    isColumnVisible = (id) => {
        return this.state.columns.filter(c => c.id == id)[0].isVisible;
    }

    onExamStartTImeChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName) => {
        let data = JSON.parse(JSON.stringify(formData));

        if ((moment(value).isAfter(getServerTime()))) {
            data[fieldName] = new Date(value).toString();
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: true,
                errorMsg: ``
            }
        } else {
            data[fieldName] = new Date(value).toString();
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: false,
                errorMsg: `Exam start date and time must be greater than current date and time.`
            }
        }

        if (!(moment(value).isBefore(data.timeFrameEnd))) {
            data.timeFrameEnd = '';
            formValidations.fields['timeFrameEnd'] = {
                ...formValidations.fields['timeFrameEnd'],
                isValid: false,
                errorMsg: `Please select exam end date, start date changed.`
            }
        }

        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    }

    onExamEndTimeChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName) => {

        let data = JSON.parse(JSON.stringify(formData));

        // Check if start date is selected first
        if (!data.fromDateTime || data.fromDateTime === '') {
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: false,
                errorMsg: `Please select start date and time first.`
            }
            thisObj.setState({
                [formName]: data,
                [formValidationName]: formValidations
            });
            return;
        }

        data[fieldName] = new Date(value).toString();
        if (moment(value).isSameOrAfter(data.fromDateTime)) {

            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: true,
                errorMsg: ``
            }
        } else {
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: false,
                errorMsg: `Exam End date must be greater than or equal to start date.`
            }
        }
        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations
        });
    }

    onTemplateChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName) => {

        let data = JSON.parse(JSON.stringify(formData));
        if (value) {
            data[fieldName] = value;
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: true,
                errorMsg: ``
            }
        } else {
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: false,
                errorMsg: `Exam End date must be greater than start date.`
            }
        }
        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations,
        }, () => this.getExamTemplate(value));
    }

    getExamTemplate = (templateId) => {
        this.setState({
            isLoading: true
        });

        this.service.get(`${baseUrlAdmin}/examtemplate/getTemplateById?templateId=${templateId}`, true).then((data) => {
            if (data && data.res && data.res.data) {
                const templateData = data.res.data;

                // Reset totalSelectedQuestions for each marking scheme
                if (templateData.subjects && templateData.subjects.length) {
                    templateData.subjects.forEach(subject => {
                        if (subject.sections && subject.sections.length) {
                            subject.sections.forEach(section => {
                                if (section.markingScheme && section.markingScheme.length) {
                                    section.markingScheme.forEach(scheme => {
                                        scheme.totalSelectedQuestions = 0;
                                    });
                                }
                            });
                        }
                    });
                }

                this.setState((prevState) => {
                    return {
                        examTemplate: templateData,
                        exam: { ...prevState.exam, ...templateData },
                        isLoading: false,
                        // Clear any previously selected questions since we're changing templates
                        selectedExamQuestions: []
                    }
                });
            } else {
                this.setState({
                    isLoading: false
                })
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
        });
    }

    recalculateSectionCounts = () => {
        const { exam, selectedExamQuestions } = this.state;
        let updatedExam = _.cloneDeep(exam);

        // First, reset all counts
        if (updatedExam.subjects && Array.isArray(updatedExam.subjects)) {
            updatedExam.subjects.forEach(subject => {
                if (subject && subject.sections && Array.isArray(subject.sections)) {
                    subject.sections.forEach(section => {
                        if (section && section.markingScheme && Array.isArray(section.markingScheme)) {
                            section.markingScheme.forEach(scheme => {
                                if (scheme) {
                                    scheme.totalSelectedQuestions = 0;
                                }
                            });
                        }
                    });
                }
            });
        }

        // Now count each question and increment the appropriate counter
        if (Array.isArray(selectedExamQuestions)) {
            selectedExamQuestions.forEach(question => {
                if (!question) return;

                // Find the subject this question belongs to
                const subject = updatedExam.subjects?.find(s => s.subjectId === question.subjectId);
                if (subject) {
                    const section = subject.sections?.find(s =>
                        // Match by sectionId if available, otherwise use sectionName
                        (question.sectionId && s.sectionId === question.sectionId) ||
                        (question.sectionName && s.sectionName === question.sectionName)
                    );

                    if (section) {
                        const scheme = section.markingScheme?.find(s => getQuestionTypeValue(s.questionType) === getQuestionTypeValue(question.questionType));
                        if (scheme) {
                            // Increment the count
                            scheme.totalSelectedQuestions = (scheme.totalSelectedQuestions || 0) + 1;
                        }
                    }
                }
            });
        }

        return updatedExam;
    }

    canAddQuestion = (finalQuestions, subjects, question) => {
        let canAdd = false;

        // Find the subject this question belongs to
        const targetSubject = subjects.find(subject => subject.subjectId == question.subjectId);
        if (!targetSubject) return false;

        // Find the appropriate section for this question type
        let targetSection = null;
        let targetScheme = null;

        // Search through sections to find one with a marking scheme for this question type
        if (targetSubject.sections && targetSubject.sections.length > 0) {
            for (const section of targetSubject.sections) {
                if (section.markingScheme && section.markingScheme.length > 0) {
                    const scheme = section.markingScheme.find(
                        scheme => getQuestionTypeValue(scheme.questionType) === getQuestionTypeValue(question.question.questionType)
                    );

                    if (scheme) {
                        targetSection = section;
                        targetScheme = scheme;
                        break;
                    }
                }
            }
        }

        if (!targetSection || !targetScheme) return false;

        // Count CURRENT questions in this section of this type
        const currentCount = finalQuestions.filter(q =>
            q.subjectId === question.subjectId &&
            q.sectionName === targetSection.sectionName &&
            getQuestionTypeValue(q.questionType) === getQuestionTypeValue(question.question.questionType)
        ).length;

        const questionsToAdd = (question.question.questions && Array.isArray(question.question.questions))
            ? question.question.questions.length  // For passage questions, count sub-questions
            : 1;  // For regular questions, count as 1

        if (currentCount + questionsToAdd <= parseInt(targetScheme.mandatoryQuestions)) {
            canAdd = true;
        }

        return canAdd;
    }

    orderQuestions = (questions, qIds) => {
        let qs = [];
        qIds.forEach(qId => {
            let inex = questions.findIndex(q => q.questionId == qId);
            if (inex >= 0) {
                let dd = JSON.parse(JSON.stringify(questions.splice(inex, 1)[0]))
                qs.push(dd);
            }

        });



        return qs.concat(questions);

    }


    onFetchQuestions = (questions, qIds) => {
        const result = this.processQuestions(questions, qIds);
        if (!result) return;

        this.handleQuestionsResult(result);
    }

    getQuestions = () => {
        let qIds = this.state.questionIds;
        this.setState({
            isLoading: true
        });

        let url = `${baseUrlAdmin}/question/questions-by-ids`
        this.service.post(url, { questionIds: qIds }, true).then((data) => {
            if (data && data.res && data.res.questions && data.res.questions.length) {
                this.setState({
                    isLoading: false,
                    questionIds: []
                }, () => {
                    this.onFetchQuestions(data.res.questions, qIds)
                });
            } else {
                this.setState({
                    isLoading: false
                });

                this.toast.show({ severity: 'error', summary: 'No questions', detail: 'No questions found with the ids.', life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
        });
    }

    openBulkQuestionSelector = () => {
        // Check if exam or subjects exists
        if (!this.state.exam || !this.state.exam.subjects || !Array.isArray(this.state.exam.subjects) || this.state.exam.subjects.length === 0) {
            this.toast.show({
                severity: 'error',
                summary: 'No subjects available',
                detail: 'Please select a template with subjects first',
                life: 3000
            });
            return;
        }

        const activeSubjectIndex = this.state.activeSubjectIndex || 0;
        // Ensure the subject at this index exists
        if (!this.state.exam.subjects[activeSubjectIndex]) {
            this.toast.show({
                severity: 'error',
                summary: 'Subject not found',
                detail: 'Selected subject is not available',
                life: 3000
            });
            return;
        }

        const subject = this.state.exam.subjects[activeSubjectIndex];

        if (!subject || !subject.sections || !Array.isArray(subject.sections) || subject.sections.length === 0) {
            this.toast.show({
                severity: 'error',
                summary: 'No sections available',
                detail: 'Please select a template with sections first',
                life: 3000
            });
            return;
        }

        // Make sure the first section has marking scheme
        if (!subject.sections[0].markingScheme || !Array.isArray(subject.sections[0].markingScheme) || subject.sections[0].markingScheme.length === 0) {
            this.toast.show({
                severity: 'error',
                summary: 'No marking scheme',
                detail: 'Section has no marking scheme defined',
                life: 3000
            });
            return;
        }

        this.setState({
            showBulkQuestionSelector: true,
            questionSelection: {
                subjectId: subject.subjectId,
                sectionName: subject.sections[0].sectionName,
                questionType: subject.sections[0].markingScheme[0].questionType
            },
            currentSubjectId: subject.subjectId,
            selectedBulkQuestions: []
        }, () => {
            this.fetchQuestionsForSection();
        });
    }

    // Modify fetchQuestionsForSection to not reset filters when applying them
    fetchQuestionsForSection = () => {
        const { questionSelection, questionFilters } = this.state;

        if (!questionSelection.subjectId) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a subject first',
                life: 3000
            });
            return;
        }

        // Only fetch chapters if they haven't been fetched already
        if (!this.state.chapters || this.state.chapters.length === 0) {
            this.fetchChaptersForSubject(questionSelection.subjectId, false);
        }

        this.setState({ isLoadingQuestions: true });

        // Prepare filters for API call
        let filters = {
            subjectId: questionSelection.subjectId,
            questionType: getQuestionTypeValue(questionSelection.questionType) || 'SCCT'
        };

        // Add optional filters if provided
        if (questionFilters.chapterId) filters.chapterId = questionFilters.chapterId;
        if (questionFilters.topicId) filters.topicId = questionFilters.topicId;
        if (questionFilters.difficulty) filters.difficulty = questionFilters.difficulty;

        // Call API to get questions
        this.service.post(`${baseUrlAdmin}/question/filter/questions`, filters, true)
            .then(response => {
                if (response && response.status && response.res && response.res.questions) {
                    // Process questions to ensure they have proper structure
                    const processedQuestions = response.res.questions.map(q => {
                        // Make sure question has the right structure for display
                        if (!q.question) {
                            return {
                                ...q,
                                question: q,  // This ensures QuestionInTable always gets a question object
                                questionId: q.questionId || q._id
                            };
                        }
                        return q;
                    });

                    this.setState({
                        availableQuestions: processedQuestions,
                        isLoadingQuestions: false
                    });
                } else {
                    this.setState({
                        availableQuestions: [],
                        isLoadingQuestions: false
                    });
                    this.toast.show({
                        severity: 'info',
                        summary: 'No questions found',
                        detail: 'No questions match your current filters',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching questions:", error);
                this.setState({ isLoadingQuestions: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch questions. Please check your filters and try again.',
                    life: 3000
                });
            });
    }

    fetchChaptersForSubject = (subjectId, resetFilters = true) => {
        const { subjects } = this.state;

        // If resetFilters is true, reset the filters; otherwise keep existing values
        if (resetFilters) {
            this.setState({
                chapters: [],
                topics: [],
                questionFilters: {
                    ...this.state.questionFilters,
                    chapterId: null,
                    topicId: null
                }
            });
        }

        if (!subjects || !Array.isArray(subjects)) return;

        // Find the selected subject in the subjects array
        const selectedSubject = subjects.find(subject => subject.subjectId === subjectId);

        if (selectedSubject && selectedSubject.chapters && Array.isArray(selectedSubject.chapters)) {
            this.setState({
                chapters: selectedSubject.chapters
            });
        }
    }

    // Update handleQuestionSelectionChange to preserve filter selections when possible
    handleQuestionSelectionChange = (field, value) => {
        if (field === 'subjectId') {
            // When subject changes, we need to reset filters as they're subject-specific
            this.setState(prevState => ({
                questionSelection: {
                    ...prevState.questionSelection,
                    [field]: value,
                    // Reset section and question type when subject changes
                    sectionName: null,
                    questionType: null
                },
                questionFilters: {
                    chapterId: null,
                    topicId: null // Reset topic when subject changes
                },
                // Clear any previously loaded chapters and topics
                chapters: [],
                topics: []
            }), () => {
                this.fetchQuestionsForSection();
            });
        } else {
            // For other filters (section, question type), just update the value
            this.setState(prevState => ({
                questionSelection: {
                    ...prevState.questionSelection,
                    [field]: value
                }
            }), () => {
                if (field === 'sectionName' || field === 'questionType') {
                    this.fetchQuestionsForSection();
                }
            });
        }
    }

    addSelectedQuestions = () => {
        const { selectedBulkQuestions, questionSelection, exam } = this.state;

        if (!selectedBulkQuestions || selectedBulkQuestions.length === 0) {
            this.toast.show({
                severity: 'warn',
                summary: 'No questions selected',
                detail: 'Please select at least one question',
                life: 3000
            });
            return;
        }

        // Find the subject and section in exam
        const subject = exam.subjects.find(s => s.subjectId === questionSelection.subjectId);
        if (!subject) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Selected subject not found in exam',
                life: 3000
            });
            return;
        }

        const section = subject.sections.find(s => s.sectionName === questionSelection.sectionName);
        if (!section) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Selected section not found in exam',
                life: 3000
            });
            return;
        }

        // Find the marking scheme for the question type
        const scheme = section.markingScheme.find(m => getQuestionTypeValue(m.questionType) === getQuestionTypeValue(questionSelection.questionType));
        if (!scheme) {
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No marking scheme found for this question type',
                life: 3000
            });
            return;
        }

        // Check if adding these questions would exceed the required count
        const currentCount = this.getSelectedQuestionCount(
            questionSelection.subjectId,
            questionSelection.sectionName,
            questionSelection.questionType
        );
        const requiredCount = parseInt(scheme.totalQuestions);

        if (currentCount + selectedBulkQuestions.length > requiredCount) {
            this.toast.show({
                severity: 'warn',
                summary: 'Too many questions',
                detail: `You can only add ${requiredCount - currentCount} more ${questionSelection.questionType} questions to this section`,
                life: 3000
            });
            return;
        }

        // Process each selected question - add section info to each question
        const questionIds = selectedBulkQuestions.map(q => q.questionId);

        // Prepare questions with section information
        const preparedQuestions = selectedBulkQuestions.map(q => ({
            ...q,
            sectionInfo: {
                subjectId: questionSelection.subjectId,
                sectionId: section.sectionId,
                sectionName: questionSelection.sectionName,
                questionType: questionSelection.questionType
            }
        }));

        // Now use the existing service call to add these questions
        this.setState({
            isLoading: true,
            showBulkQuestionSelector: false,
            // Store the section info for later use
            currentSectionInfo: {
                subjectId: questionSelection.subjectId,
                sectionId: section.sectionId,
                sectionName: questionSelection.sectionName
            }
        });

        const url = `${baseUrlAdmin}/question/questions-by-ids`;
        this.service.post(url, {
            questionIds: questionIds,
            sectionInfo: {
                subjectId: questionSelection.subjectId,
                sectionId: section.sectionId,
                sectionName: questionSelection.sectionName,
                questionType: questionSelection.questionType
            }
        }, true)
            .then((data) => {
                if (data && data.res && data.res.questions && data.res.questions.length) {
                    // Add section info to the fetched questions
                    const questionsWithSectionInfo = data.res.questions.map(q => ({
                        ...q,
                        selectedSectionInfo: {
                            subjectId: questionSelection.subjectId,
                            sectionId: section.sectionId,
                            sectionName: questionSelection.sectionName,
                            questionType: questionSelection.questionType
                        }
                    }));

                    this.setState({ isLoading: false }, () => {
                        // Pass the modified questions to onFetchQuestions
                        this.onFetchQuestionsWithSection(questionsWithSectionInfo, questionIds);
                    });
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({
                        severity: 'error',
                        summary: 'No questions',
                        detail: 'No questions found with the selected IDs.',
                        life: 3000
                    });
                }
            })
            .catch(e => {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch questions. Please try again.',
                    life: 3000
                });
            });
    }

    // Add a new method to handle questions with section information
    onFetchQuestionsWithSection = (questions, qIds) => {
        const result = this.processQuestions(questions, qIds,
            questions[0]?.selectedSectionInfo // Pass section info from bulk selection
        );
        if (!result) return;

        this.handleQuestionsResult(result);
    }

    // Add helper method to handle the results
    handleQuestionsResult = (result) => {
        const { finalQuestions, notFitQuestions, questionsNotInSubjects, newlyAddedQs } = result;

        if (notFitQuestions.length || questionsNotInSubjects.length) {
            this.toast.show({
                severity: 'error',
                summary: 'Some questions could not be added',
                detail: `Questions that don't fit criteria: ${notFitQuestions.join(', ')}. 
                    Questions not in selected subjects: ${questionsNotInSubjects.join(', ')}.`,
                life: 20000
            });
        }

        if (newlyAddedQs.length > 0) {
            const updatedExam = this.recalculateSectionCounts();
            this.setState({
                selectedExamQuestions: finalQuestions,
                exam: updatedExam
            });

            // Calculate total selected questions, including the ones we just added
            const previousQuestionsCount = finalQuestions.length - this.countAddedQuestions(newlyAddedQs, finalQuestions);
            const addedQuestionsCount = this.countAddedQuestions(newlyAddedQs, finalQuestions);

            // Show success message with the actual count of added questions
            this.toast.show({
                severity: 'success',
                summary: 'Success',
                detail: `${addedQuestionsCount} questions were added successfully.`,
                life: 10000
            });
        }
    }

    // Add this helper method to count actual added questions, including passage sub-questions
    countAddedQuestions = (newlyAddedQIds, finalQuestions) => {
        let count = 0;

        // Count regular questions directly
        const regularQuestions = newlyAddedQIds.filter(id =>
            !finalQuestions.some(q => q.psgQId === id)
        ).length;

        // For passage questions, count all their sub-questions
        const passageSubQuestionCount = finalQuestions.filter(q =>
            newlyAddedQIds.includes(q.psgQId)
        ).length;

        return regularQuestions + passageSubQuestionCount;
    }

    getSelectedQuestionCount = (subjectId, sectionName, questionType) => {
        const { selectedExamQuestions } = this.state;

        if (!subjectId || !sectionName || !questionType || !selectedExamQuestions) {
            return 0;
        }

        // First, normalize the questionType to make comparison consistent
        const normalizedType = getQuestionTypeValue(questionType);

        // Count all questions that match the criteria
        return selectedExamQuestions.filter(question =>
            question &&
            question.subjectId === subjectId &&
            question.sectionName === sectionName &&
            getQuestionTypeValue(question.questionType) === normalizedType
        ).length;
    }

    getRequiredQuestionCount = (subjectId, sectionName, questionType) => {
        const { exam } = this.state;

        if (!subjectId || !sectionName || !questionType) return 0;

        const subject = exam?.subjects?.find(s => s.subjectId === subjectId);
        if (!subject) return 0;

        const section = subject.sections?.find(s => s.sectionName === sectionName);
        if (!section) return 0;

        const markingScheme = section.markingScheme?.find(m => m.questionType === questionType);
        if (!markingScheme) return 0;

        // CHANGED: Return total questions (mandatory + optional) instead of just mandatory
        const mandatoryQuestions = parseInt(markingScheme.mandatoryQuestions || 0);
        const optionalQuestions = parseInt(markingScheme.optionalQuestions || 0);

        return mandatoryQuestions + optionalQuestions; // Total questions needed for exam creation
    };

    handleFilterChange = (field, value) => {
        // Store the current filter state to retain other selections
        const currentFilters = { ...this.state.questionFilters };

        if (field === 'chapterId') {
            const selectedChapter = this.state.chapters.find(chapter => chapter.chapterId === value);
            this.setState({
                questionFilters: {
                    ...currentFilters,
                    chapterId: value,
                    topicId: null
                },
                topics: selectedChapter && selectedChapter.topics ? selectedChapter.topics : []
            });
        } else {
            // For other filters (topic, difficulty), just update the value
            this.setState({
                questionFilters: {
                    ...currentFilters,
                    [field]: value
                }
            });
        }
    }

    // Add this new method to the class
    findSectionForQuestion = (subjects, question) => {
        // Find the appropriate section for this question type
        const targetSubject = subjects.find(subject => subject.subjectId === question.subjectId);
        if (!targetSubject) return null;

        // Find section with matching marking scheme
        for (const section of targetSubject.sections || []) {
            if (section.markingScheme && Array.isArray(section.markingScheme)) {
                const matchingScheme = section.markingScheme.find(
                    scheme => getQuestionTypeValue(scheme.questionType) === getQuestionTypeValue(question?.questionType)
                );

                if (matchingScheme) {
                    return {
                        sectionName: section.sectionName,
                        sectionId: section.sectionId
                    };
                }
            }
        }

        return null;
    }

    // Add this method to calculate the total marks based on selected questions
    calculateTotalMarks = () => {
        const { exam, selectedExamQuestions } = this.state;
        let totalMarks = 0;

        if (exam?.subjects && Array.isArray(exam.subjects)) {
            // Go through each subject, section, and marking scheme
            exam.subjects.forEach(subject => {
                if (subject?.sections && Array.isArray(subject.sections)) {
                    subject.sections.forEach(section => {
                        if (section?.markingScheme && Array.isArray(section.markingScheme)) {
                            section.markingScheme.forEach(scheme => {
                                // Count how many questions of this type are in this section
                                const questionCount = selectedExamQuestions.filter(q =>
                                    q.subjectId === subject.subjectId &&
                                    q.sectionName === section.sectionName &&
                                    getQuestionTypeValue(q.questionType) === getQuestionTypeValue(scheme.questionType)
                                ).length;

                                // CHANGED: Only calculate marks for mandatory questions, not all questions
                                const mandatoryQuestionsCount = parseInt(scheme.mandatoryQuestions || 0);
                                const marksToCalculate = Math.min(questionCount, mandatoryQuestionsCount);

                                // Add the marks for these questions
                                totalMarks += marksToCalculate * parseInt(scheme.positiveMarking || 0);
                            });
                        }
                    });
                }
            });
        }

        return totalMarks;
    }

    createExam = async (examToSave) => {
        const response = await this.service.post(
            `${baseUrlAdmin}/examination/add-exam-test`,
            examToSave,
            true
        );

        if (response?.res?.success) {
            this.setState({ isLoading: false }, () => {
                this.toast.show({
                    severity: 'success',
                    summary: 'Hurray!',
                    detail: 'Exam Successfully created',
                    life: 3000
                });

                if (typeof this.props.onCreateSuccess === 'function') {
                    this.props.onCreateSuccess();
                }

                setTimeout(() => {
                    this.props.navigate("/TestsandExams");
                }, 1000);
            });
        } else {
            throw new Error('Unable to create exam record');
        }
    }

    updateExam = async (examToSave) => {
        const response = await this.service.put(
            `${baseUrlAdmin}/examination/${this.state.exam.examId}/exam-type/AdhocMockTest/update-exam`,
            examToSave,
            true
        );

        if (response?.res?.success) {
            this.setState({ isLoading: false }, () => {
                this.toast.show({
                    severity: 'success',
                    summary: 'Hurray!',
                    detail: 'Exam Successfully edited',
                    life: 3000
                });

                if (typeof this.props.onCreateSuccess === 'function') {
                    this.props.onCreateSuccess(true);
                }

                setTimeout(() => {
                    this.props.navigate("/TestsandExams");
                }, 1000);
            });
        } else {
            throw new Error('Unable to update exam record');
        }
    }

    // Updated processQuestions method to extract sub-questions from passages
    processQuestions = (questions, qIds, sectionInfo = null) => {
        // Validate and order questions
        if (!questions || !questions.length) return null;
        questions = this.orderQuestions(questions, qIds);

        // Check for missing questions
        const notFoundQuestions = qIds.filter(id => !questions.find(q => q.questionId === id));
        if (notFoundQuestions.length) {
            this.toast.show({
                severity: 'error',
                summary: 'Questions are not added due to some questions not found.',
                detail: `Having issue with the following questions: ${notFoundQuestions.join(',')}.`,
                life: 20000
            });
            return null;
        }

        const { exam, selectedExamQuestions } = this.state;
        const subjectIds = exam.subjects.map(q => q.subjectId);
        const finalQuestions = _.cloneDeep(selectedExamQuestions);
        const examT = _.cloneDeep(exam);

        // Check for duplicates - include checking sub-questions
        const duplicateQuestionIds = [];
        questions.forEach(q => {
            if (!q?.question) return;

            if (['PSGS', 'PSGM'].includes(q.questionType)) {
                // For passage questions, check each sub-question
                if (q.questions && Array.isArray(q.questions)) {
                    q.questions.forEach(subQ => {
                        if (finalQuestions.find(fq => fq.questionId === subQ.questionId)) {
                            duplicateQuestionIds.push(subQ.questionId);
                        }
                    });
                }
            } else {
                // For regular questions, check the question ID
                if (finalQuestions.find(fq => fq.questionId === q.questionId)) {
                    duplicateQuestionIds.push(q.questionId);
                }
            }
        });

        if (duplicateQuestionIds.length) {
            this.toast.show({
                severity: 'error',
                summary: 'Questions are not added due to duplicate questions.',
                detail: `Having issue with the following questions: ${duplicateQuestionIds.join(',')}.`,
                life: 20000
            });
            return null;
        }

        const questionsNotInSubjects = [];
        const newlyAddedQs = [];
        const notFitQuestions = [];

        // Process each question
        questions.forEach(q => {
            if (!subjectIds.includes(q.subjectId)) {
                questionsNotInSubjects.push(q.questionId);
                return;
            }

            const targetSubject = examT.subjects.find(subject => subject.subjectId === q.subjectId);
            if (!targetSubject) {
                questionsNotInSubjects.push(q.questionId);
                return;
            }

            // Get section info either from passed parameter or find it
            const targetSectionInfo = sectionInfo || this.findSectionForQuestion(examT.subjects, q);
            if (!targetSectionInfo) {
                notFitQuestions.push(q.questionId);
                return;
            }

            const targetSection = targetSubject.sections.find(
                section => section.sectionName === targetSectionInfo.sectionName
            );

            if (!targetSection) {
                notFitQuestions.push(q.questionId);
                return;
            }

            const questionType = q.questionType || (q.question && q.question.questionType);
            const targetScheme = targetSection.markingScheme.find(
                scheme => getQuestionTypeValue(scheme.questionType) === questionType
            );

            if (!targetScheme) {
                notFitQuestions.push(q.questionId);
                return;
            }

            const currentCount = finalQuestions.filter(fq =>
                fq.subjectId === q.subjectId &&
                fq.sectionName === targetSection.sectionName &&
                getQuestionTypeValue(fq.questionType) === questionType
            ).length;

            if (['PSGS', 'PSGM', 'PQS', 'PQM'].includes(questionType)) {
                // NEW BEHAVIOR: Extract all sub-questions and add them as individual questions
                if (!q.questions || !Array.isArray(q.questions)) {
                    notFitQuestions.push(q.questionId);
                    return;
                }

                // Check if adding all sub-questions would exceed the required count
                if (currentCount + q.questions.length > parseInt(targetScheme.totalQuestions)) {
                    notFitQuestions.push(q.questionId);
                    return;
                }

                // Add each sub-question as a separate main question
                q.questions.forEach((subQ, index) => {
                    finalQuestions.push({
                        ...subQ,
                        subjectId: q.subjectId,
                        sectionName: targetSectionInfo.sectionName,
                        sectionId: targetSection.sectionId,
                        questionType: subQ.questionType || questionType,
                        // Keep reference to original passage question for grouping/display
                        psgQId: q.questionId,
                        // Add any other needed metadata
                        originalPassageQuestion: {
                            questionId: q.questionId,
                            question: q.question || q.passage || '',
                            paragraph: q.paragraph || '',
                            paragraphUrl: q.paragraphUrl || '',
                        }
                    });
                });

                // Add the passage question ID to newly added
                newlyAddedQs.push(q.questionId);
            } else if (currentCount < parseInt(targetScheme.totalQuestions)) {
                // Regular question handling (unchanged)
                finalQuestions.push({
                    ...q,
                    subjectId: q.subjectId,
                    psgQId: '',
                    sectionName: targetSectionInfo.sectionName,
                    sectionId: targetSection.sectionId,
                    questionType
                });
                newlyAddedQs.push(q.questionId);
            } else {
                notFitQuestions.push(q.questionId);
            }
        });

        return {
            finalQuestions,
            notFitQuestions,
            questionsNotInSubjects,
            newlyAddedQs
        };
    }

    render() {
        const { exam, formValidations, questions, selectedExamQuestions } = this.state;
        console.log('state', this.state)
        const header = (
            <div className="table-header ma-tbl-header">
                <div className="ma-tbl-left">
                    <h2 className='ma-table-title'>Questions List</h2>
                    {this.state.showSearch && <InputText placeholder="Search" value={this.state.globalFilter} className="ma-tbl-search p-inputtext-md" onChange={(e) => {
                        this.setState({
                            globalFilter: e.target.value
                        })
                    }} />}

                </div>

                <div className="p-input-icon-left ma-tbl-filter">
                    <ul className="ma-tbl-li">
                        {/* <Authorizer permId={PERMISSIONS.ORG_SEARCH} > */}
                        {/* <li><i data-pr-tooltip="Search" data-pr-position="bottom" className="pi pi-search ma-tbl-icon ma-tbl-srch" onClick={(e) => { this.setState({ showSearch: !this.state.showSearch, globalFilter: '' }) }}></i></li>
                        <Tooltip className="table-li-tooltip" autoHide={false} target=".ma-tbl-srch" /> */}
                        {/* </Authorizer> */}
                        {/* <li><i data-pr-tooltip="Filter" data-pr-position="bottom" className="pi pi-filter ma-tbl-icon ma-tbl-fi"></i></li>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-fi" /> */}
                        {/* <Authorizer permId={PERMISSIONS.ORG_VIEW_COLUMNS} > */}
                        <li><i onClick={(event) => this.menu.toggle(event)} data-pr-tooltip="View Columns" data-pr-position="bottom" className="pi pi-sort-alt ma-tbl-icon ma-tbl-sort"></i></li>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-sort" />
                        {/* </Authorizer> */}
                        {/* <Authorizer permId={PERMISSIONS.ORG_DOWNLOAD} >
                            <li><i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV}></i></li>
                            <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" />
                        </Authorizer> */}
                    </ul>
                </div>
                <Menu
                    className='table-filter-w'
                    model={[
                        {
                            template: (<div className='table-filter'>
                                <h4 className="filter-title">View Columns</h4>
                                <ul>
                                    {this.state.columns.map((column) => {
                                        return <li onClick={() => this.onColumnClick(column)}><Checkbox inputId={column.id}
                                            checked={column.isVisible}
                                        ></Checkbox>
                                            <label htmlFor={column.id} className="p-checkbox-label p-name">{column.columnName}</label>
                                        </li>
                                    })}
                                </ul>
                            </div>)
                        }]
                    }
                    popup
                    ref={el => this.menu = el} />
            </div>
        );
        //   console.log('this.props', this.props)
        return (<div className='create-quiz'>
            {this.state.currentStep == 1 && (
                <ExamDetailsForm
                    exam={exam}
                    formValidations={formValidations}
                    examTemplates={this.state.examTemplates}
                    boards={this.props.boards}
                    classes={this.state.classes}
                    subjects={this.state.subjects}
                    boardId={this.state.boardId}
                    classId={this.state.classId}
                    isEditMode={!!this.props.editExamId}
                    onTextChange={(field, value) => {
                        // Handle totalTime as number field
                        if (field === 'totalTime') {
                            onNumberChange(value, field, this, adhocFields, exam, formValidations, 'exam', 'formValidations');
                        } else {
                            onTextChange(value, field, this, adhocFields, exam, formValidations, 'exam', 'formValidations');
                        }
                    }}
                    onDropDownChange={(field, value) => {
                        onDropDownChange(value, field, this, adhocFields, exam, formValidations, 'exam', 'formValidations');
                        if (field === 'testType') {
                            this.updateDateFileds(value);
                        }
                    }}
                    onTemplateChange={(value) => this.onTemplateChange(value, 'templateId', this, adhocFields, exam, formValidations, 'exam', 'formValidations')}
                    onBoardChange={this.onChangeBoard}
                    onClassChange={this.onChangeClass}
                    onSubjectChange={this.onChangeSubject}
                    onExamStartTimeChange={(value) => this.onExamStartTImeChange(value, 'fromDateTime', this, adhocFields, exam, formValidations, 'exam', 'formValidations')}
                    onExamEndTimeChange={(value) => this.onExamEndTimeChange(value, 'toDateTime', this, adhocFields, exam, formValidations, 'exam', 'formValidations')}
                />
            )}

            {this.state.currentStep == 2 && (
                <>
                    <div className='ma-right mb-3'>
                        <p className='adhoc-q-select-c'> <span>{selectedExamQuestions.length}</span> out of {exam.totalNoOfQuestions} Questions selected</p>
                        <p className='adhoc-q-select-c'>Total Time: <span>{exam.totalTime || 0}</span> minutes</p>
                        <p className='adhoc-q-select-c'>All subjects total marks: <span>{this.calculateTotalMarks()}</span></p>
                    </div>
                    <div className='ma-clearFix'></div>

                    <div className='adhoc-q-t mb-4'>
                        <div className="p-grid ma-w100p ma-p20">
                            <div className="p-col-12 p-md-6">
                                <TabView
                                    activeIndex={this.state.activeSubjectIndex}
                                    onTabChange={(e) => this.setState({ activeSubjectIndex: e.index })}
                                    className="adhoc-subjects-tabs"
                                >
                                    {exam.subjects && exam.subjects.length > 0 ? exam.subjects.map((subject) => {
                                        return (
                                            <TabPanel key={subject.id || `subject-${subject.subjectId}`} header={subject.subjectName || 'Subject'}>
                                                {subject.sections && subject.sections.length > 0 ? (
                                                    subject.sections.map((section, sectionIndex) => (
                                                        <div key={`section-${sectionIndex}`} className="section-container mb-3 p-2 border-1 border-round surface-100">
                                                            <h4 className="section-name mb-2">{section.sectionName}</h4>
                                                            <div className="section-info mb-2 flex align-items-center justify-content-between">
                                                                <span>Total Questions: {section.totalQuestions}</span>
                                                                <span>Instruction: {section.sectionInstruction}</span>
                                                            </div>

                                                            {section.markingScheme && section.markingScheme.length > 0 ? (
                                                                section.markingScheme.map((scheme, schemeIndex) => (
                                                                    <div key={`scheme-${sectionIndex}-${schemeIndex}`} className="adhoc-q-selection">
                                                                        <span className='q-t-label'>{scheme.questionType}</span>
                                                                        <span className='q-t-counts'>
                                                                            {this.getSelectedQuestionCount(
                                                                                subject.subjectId,
                                                                                section.sectionName,
                                                                                scheme.questionType
                                                                            )} / {scheme.totalQuestions || 0}
                                                                        </span>
                                                                        <span className='q-t-label q-tl2 ma-ml20'>{scheme.questionType} Marks</span>
                                                                        <span className='q-t-counts'>
                                                                            {parseInt(scheme.mandatoryQuestions || 0) * parseInt(scheme.positiveMarking || 0)}
                                                                        </span>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div className="p-2">No marking scheme available for this section</div>
                                                            )}
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="p-3">No sections available for this subject</div>
                                                )}
                                            </TabPanel>
                                        );
                                    }) : (
                                        <TabPanel header="No Subjects">
                                            <div>No subjects available. Please select a template first.</div>
                                        </TabPanel>
                                    )}
                                </TabView>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="p-card p-3 border-1 surface-border border-round">
                                    <div className="mb-3">
                                        <p className='ma-label-s2 mb-2'>Enter question Ids</p>
                                        <div>
                                            <Chips
                                                className='w-full'
                                                value={this.state.questionIds}
                                                onChange={(e) => {
                                                    const cleanedValues = e.value
                                                        .map(val => {
                                                            return String(val)
                                                                .replace(/[\r\n\t]/g, '')
                                                                .replace(/^\s+|\s+$/g, '')
                                                                .replace(/\s+/g, ' ')
                                                                .trim();
                                                        })
                                                        .filter(val => val.length > 0);

                                                    this.setState({
                                                        questionIds: cleanedValues
                                                    })
                                                }}
                                                separator=','
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-content-between align-items-center mt-3">
                                        <Button
                                            label='Choose'
                                            icon="pi pi-list"
                                            className='p-button-secondary'
                                            onClick={this.openBulkQuestionSelector}
                                        />
                                        <Button
                                            label='Add Questions'
                                            icon="pi pi-plus"
                                            className='add-questions p-button-primary'
                                            onClick={this.getQuestions}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add clear separation between the question entry area and the table */}
                    <div className="mb-4"></div>

                    <div className="card datatable-crud-demo fetch-q-tabled fetch-q-table">
                        <DataTable
                            ref={(el) => this.dt = el}
                            scrollable
                            scrollHeight="500px"
                            responsiveLayout="scroll"
                            dataKey="_id"
                            value={
                                this.state.selectedExamQuestions
                                    .filter(question =>
                                        this.state.exam.subjects[this.state.activeSubjectIndex || 0]?.subjectId === question.subjectId
                                    )
                                    .sort((a, b) => {
                                        if (this.props.editExamId) {
                                            // In edit mode, prioritize sorting by qNo
                                            // Convert to numbers for proper numeric sorting
                                            const aNum = parseInt(a.qNo) || 0;
                                            const bNum = parseInt(b.qNo) || 0;
                                            return aNum - bNum;
                                        } else {
                                            // In create mode, sort by section name first
                                            if (a.sectionName !== b.sectionName) {
                                                return (a.sectionName || '').localeCompare(b.sectionName || '');
                                            }
                                            // Then by question number if available
                                            return (parseInt(a.qNo) || 0) - (parseInt(b.qNo) || 0);
                                        }
                                    })
                            }
                            className="ma-table-d"
                            tableClassName='ma-table-tbl'
                            paginatorLeft={() => {
                                return (
                                    <p className='avail-q'> Questions selected: <span>{this.state.selectedExamQuestions.length}</span> </p>
                                );
                            }}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            header={header}
                        >

                            {this.props.editExamId && <Column headerClassName='questionNo' field="qNo" header="Question No" />}
                            <Column headerClassName='section-name' field="sectionName" header="Section" />
                            <Column filterField='questionId' headerClassName='question-id' field="questionId" header="Question ID" />
                            <Column filterField='questionType' headerClassName='question-type' field="questionType" header="Question Type"

                                body={(rowData) => {
                                    if (['PSGS', 'PSGM'].includes(rowData.questionType)) {
                                        return `${rowData.questionType} (${rowData.questions?.length || 0} sub-questions)`;
                                    }
                                    return rowData.questionType;
                                }}
                            />
                            <Column headerClassName='difficulty' headerStyle={{ width: '140px' }} header="Actions" body={(rowData) => {
                                return (
                                    <>
                                        <span data-pr-tooltip="Preview Question" data-pr-position="bottom" className={`preview${rowData._id} ma-mr20`}
                                            onClick={() => {
                                                this.setState({
                                                    isShowQuestionPreview: true,
                                                    questionToPreview: rowData
                                                });
                                            }}>
                                            <PreviewIcon width={20} height={20} />
                                        </span>
                                        <Tooltip className="table-li-tooltip2" autoHide={false} target={`.preview${rowData._id}`} />

                                        <span data-pr-tooltip="Remove" data-pr-position="bottom" className={`delete${rowData._id}`}
                                            onClick={() => this.removeQuestion(rowData)}>
                                            <DeleteIcon width={20} height={20} />
                                        </span>
                                        <Tooltip className="table-li-tooltip2" autoHide={false} target={`.delete${rowData._id}`} />
                                    </>
                                );
                            }} />
                        </DataTable>
                    </div>
                </>
            )}


            <Toolbar className="ma-toolbard ma-mt20" right={() => <>
                {
                    this.state.currentStep == 2 && <Button label='Previous' className='ma-m-lr10 p-button-outlined'
                        onClick={() => {
                            this.setState({
                                currentStep: 1
                            }, () => {
                                // Notify parent component of step change
                                if (this.props.onStepChange) {
                                    this.props.onStepChange(1);
                                }
                            })
                        }} />
                }

                <Button label='Proceed' className='ma-m-lr10'
                    onClick={this.onProceed}

                />

            </>}

            ></Toolbar>



            {
                this.state.isShowQuestionPreview && <PreviewQuestion
                    question={this.state.questionToPreview}
                    onHide={() => {
                        this.setState({
                            isShowQuestionPreview: false
                        })
                    }}
                />
            }
            {
                (this.state.isLoading || this.props.isLoading) && <LoadingComponent />
            }
            <Toast ref={(el) => this.toast = el} position="bottom-right" />

            <BulkQuestionSelector
                visible={this.state.showBulkQuestionSelector}
                exam={this.state.exam}
                questionSelection={this.state.questionSelection}
                questionFilters={this.state.questionFilters}
                chapters={this.state.chapters}
                topics={this.state.topics}
                availableQuestions={this.state.availableQuestions}
                selectedBulkQuestions={this.state.selectedBulkQuestions}
                isLoadingQuestions={this.state.isLoadingQuestions}
                onHide={() => this.setState({ showBulkQuestionSelector: false })}
                onQuestionSelectionChange={this.handleQuestionSelectionChange}
                onFilterChange={this.handleFilterChange}
                onSelectionChange={(value) => this.setState({ selectedBulkQuestions: value })}
                onAddQuestions={this.addSelectedQuestions}
                getSelectedQuestionCount={this.getSelectedQuestionCount}
                getRequiredQuestionCount={this.getRequiredQuestionCount}
                fetchQuestionsForSection={this.fetchQuestionsForSection}
                onPreviewQuestion={(rowData) => {
                    try {
                        let questionToPreview;

                        // Handle PSGS/PSGM passage questions differently
                        if (rowData.questionType === 'PSGS' || rowData.questionType === 'PSGM') {
                            // For passage questions, use the original structure
                            questionToPreview = { ...rowData };
                        } else {
                            // For regular questions, use existing logic
                            questionToPreview = rowData.question && typeof rowData.question === 'object'
                                ? { ...rowData.question }
                                : { ...rowData };

                            if (!questionToPreview.questionType) {
                                questionToPreview.questionType = rowData.questionType || "SCCT";
                            }
                        }

                        this.setState({
                            isShowQuestionPreview: true,
                            questionToPreview
                        });
                    } catch (error) {
                        this.toast.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Could not preview this question: ' + error.message,
                            life: 3000
                        });
                    }
                }}
            />
        </div >)
    }
}


const mapsStatesToProps = (state) => {
    return {
        boards: userAssignedBoards(state, 'activeBoards'),
        isLoading: state.boardsData.loading,
    };
};

export default connect(mapsStatesToProps, {
    getBoardsData,
})(withRouter(CreateAdhoc));
